export const getObjectKey = (key: string, obj: any) => {
    return obj[key]
  }